

import React, { Component } from 'react'
class Footer extends Component {
    render() {
        return (

            <footer className="footer">
                <span>
                    © {`${new Date().getFullYear()}`} Asepsis Pty Ltd. All rights reserved. Powered by Asepsis. <img src={"/favicon-2.png"} width={30} />
                </span>
            </footer>
        )
    }
}
Footer.defaultProps = {}

export default Footer;

